import { gql } from '@apollo/client'

export const GET_SEGMENTS = gql`
  query GetSegments($routeId: ID) {
    segments(input: { limit: 1000, routeID: $routeId }) {
      id
      origin {
        name
        code
        id
      }
      destination {
        name
        code
        id
      }
      companyLineSpecs {
        companyLine {
          id
          name
        }
        duration
        distance
      }
    }
  }
`

export const GET_SEGMENTS_WITH_PAGINATION = gql`
  query GetSegmentsWithPagination($pagination: Pagination, $input: segmentsQueryInput) {
    segmentsWithPagination(pagination: $pagination, input: $input) {
      total
      items {
        id
        origin {
          name
          code
          id
        }
        destination {
          name
          code
          id
        }
        companyLineSpecs {
          companyLine {
            id
            name
          }
          duration
          distance
          fares {
            subtotal
          }
        }
        company {
          id
          name
        }
        duration @client
        distance @client
        hasAllPrices @client
      }
    }
  }
`

export const GET_SEGMENTS_SUGGESTIONS = gql`
  query GetSegmentsSuggestions($input: SegmentSuggestionsInput!, $pagination: PaginationV2) {
    segmentSuggestions(input: $input, pagination: $pagination) {
      items {
        id
        name
        origin {
          id
          name
          code
          cityID
        }
        destination {
          id
          name
          code
          cityID
        }
      }
    }
  }
`
